import { mapState, mapGetters, mapActions } from 'vuex'

export const authComputed = {
  ...mapState('auth', {
    currentUser: (state) => state.currentUser,
  }),
  ...mapGetters('auth', ['loggedIn']),
}

/**
 * Rol del empleado autenticado. Se usa para ocultar las acciones de escritura
 * al rol "lector".
 */
export const empleadoComputed = {
  ...mapGetters('empleado', ['rol', 'esAdmin', 'puedeEditar', 'autorizado']),
}

/**
 * Cliente autenticado en el portal web y su estado de membresía.
 */
export const clienteComputed = {
  // Los nombres llevan sufijo para no chocar con `empleadoComputed`, que expone
  // getters homónimos (`autorizado`, `nombre`) desde el otro módulo.
  ...mapGetters('cliente', {
    clienteAutorizado: 'autorizado',
    nombreCliente: 'nombre',
    tieneMembresia: 'tieneMembresia',
    estadoMembresia: 'estadoMembresia',
    perfilIncompleto: 'perfilIncompleto',
    esComercio: 'esComercio',
  }),
  ...mapState('cliente', {
    perfilCliente: (state) => state.perfil,
    cargandoCliente: (state) => state.cargando,
  }),
}

/** Ficha del negocio del comercio autenticado. */
export const negocioComputed = {
  ...mapGetters('negocio', ['tieneNegocio', 'nombreNegocio']),
  ...mapState('negocio', {
    fichaNegocio: (state) => state.ficha,
    cargandoNegocio: (state) => state.cargando,
  }),
}

export const layoutComputed = {
  ...mapState('layout', {
    layoutType: (state) => state.layoutType,
  })
}

export const authMethods = mapActions('auth', [
  'logIn',
  'logInConCredencialGoogle',
  'metodosDeAcceso',
  'logOut',
  'register',
  'resetPassword',
])

export const layoutMethods = mapActions('layout', ['changeLayoutType'])

export const authFackMethods = mapActions('authfack', ['login', 'registeruser', 'logout'])

export const notificationMethods = mapActions('notification', ['success', 'error', 'clear'])
